import api from './axios';

export const getNotifications   = (params) => api.get('/notifications', { params });
export const getUnreadCount     = ()        => api.get('/notifications/unread-count');
export const markAsRead         = (id)      => api.post(`/notifications/${id}/read`);
export const markAllAsRead      = ()        => api.post('/notifications/read-all');
export const sendNotification   = (data)    => api.post('/notifications/send', data);
export const deleteNotification = (id)      => api.delete(`/notifications/${id}`);
export const getAdminNotifications = (params) => api.get('/admin/notifications', { params });
